import React, {useCallback, useEffect, useState} from "react";
import lien from './lien'
import './css/dash.scss'
import UserItem from "./UserItem";

export default function User(props) {
    const [listItem, setListItem] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    ///////////////////fetchApi/////////////////////////
    const fetchAPI = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);

            // Vérifier si l'utilisateur est connecté
            let idUser = localStorage.getItem("utilisateur") ? parseInt("" + localStorage.getItem("utilisateur")) : null;
            let str = "" + localStorage.getItem('jwt');

            const response = await fetch(lien.url + "connection/");

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const resbis = await response.json();
            setListItem(resbis || []);
            return resbis;
        } catch (error) {
            console.error("Erreur lors de la récupération des utilisateurs:", error);
            setError("Impossible de charger la liste des utilisateurs");
            return [];
        } finally {
            setIsLoading(false);
        }
    }, []);

    //////////////////////////appel api au début
    useEffect(() => {
        fetchAPI();
    }, [fetchAPI]);

    /////////////////////////
    if (!localStorage.getItem('jwt')) {
        return <p style={{color: "red", textAlign: "center"}}>Veuillez vous connecter.</p>;
    }

    return (
        <div className="user-container">
            <div className="div2">
                {isLoading ? (
                    <p className="loading-message">Chargement des utilisateurs...</p>
                ) : error ? (
                    <p className="error-message">{error}</p>
                ) : listItem && listItem.length > 0 ? (
                    <div className="containerAll">
                        {listItem.map((item, index) => (
                            <UserItem
                                key={index}
                                nom={item.nom}
                                prenom={item?.prenom}
                                email={item.email}
                                role={item.role}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="no-users-message">
                        <p>Aucun utilisateur trouvé.</p>
                        <button onClick={fetchAPI} className="refresh-button">
                            Rafraîchir la liste
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}